import { connect } from 'react-redux'
import { CreateMediaTypeGroupForm } from './CreateMediaTypeGroupForm'
import { selectMediaTypeGroup } from '../../selectors/mediaTypesGroups'
import { AppStateType } from '../../reducers'

const mapStateToProps = (state: AppStateType) => ({
  mediaTypeGroup: selectMediaTypeGroup(state),
})

export default connect(mapStateToProps)(CreateMediaTypeGroupForm)
